import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, NewspaperIcon, PlusCircleIcon, BarChartIcon, SettingsIcon, LogOutIcon, UsersIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
export const DashboardSidebar = () => {
  const {
    logout,
    userProfile
  } = useAuth();
  const location = useLocation();
  const handleLogout = async () => {
    try {
      await logout();
      // Redirect happens automatically via protected route
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };
  const navItems = [{
    name: 'Dashboard',
    href: '/dashboard',
    icon: LayoutDashboardIcon
  }, {
    name: 'My Articles',
    href: '/dashboard/articles',
    icon: NewspaperIcon
  }, {
    name: 'Create Article',
    href: '/dashboard/articles/new',
    icon: PlusCircleIcon
  }, {
    name: 'Analytics',
    href: '/dashboard/analytics',
    icon: BarChartIcon
  }, {
    name: 'Team',
    href: '/dashboard/team',
    icon: UsersIcon
  }, {
    name: 'Settings',
    href: '/dashboard/settings',
    icon: SettingsIcon
  }];
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <div className="h-screen flex flex-col bg-white border-r border-gray-200 w-64 flex-shrink-0" data-id="element-56">
      <div className="p-4 border-b border-gray-200" data-id="element-57">
        <h2 className="text-xl font-bold" data-id="element-58">PROTOCOL</h2>
        <p className="text-sm text-gray-500" data-id="element-59">Reporter Dashboard</p>
      </div>
      <div className="p-4 border-b border-gray-200" data-id="element-60">
        <div className="flex items-center space-x-3" data-id="element-61">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-62">
            {userProfile?.avatarUrl ? <img src={userProfile.avatarUrl} alt={userProfile.name} className="w-10 h-10 rounded-full object-cover" data-id="element-63" /> : <span className="text-blue-600 font-medium" data-id="element-64">
                {userProfile?.name?.charAt(0) || 'U'}
              </span>}
          </div>
          <div data-id="element-65">
            <h3 className="font-medium" data-id="element-66">{userProfile?.name || 'Reporter'}</h3>
            <p className="text-xs text-gray-500 capitalize" data-id="element-67">
              {userProfile?.role || 'Reporter'}
            </p>
          </div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto p-4" data-id="element-68">
        <ul className="space-y-1" data-id="element-69">
          {navItems.map(item => <li key={item.name} data-id="element-70">
              <Link to={item.href} className={`flex items-center px-3 py-2 rounded-md text-sm ${isActive(item.href) ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-71">
                <item.icon className="h-5 w-5 mr-3" data-id="element-72" />
                {item.name}
              </Link>
            </li>)}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-200" data-id="element-73">
        <button onClick={handleLogout} className="flex items-center px-3 py-2 w-full rounded-md text-sm text-gray-700 hover:bg-gray-100" data-id="element-74">
          <LogOutIcon className="h-5 w-5 mr-3" data-id="element-75" />
          Sign Out
        </button>
      </div>
    </div>;
};